import { defaultPalette } from "./palette/default";
import { primaryPalette } from "./palette/primary";

export const themes = {
  default: defaultPalette,
  primary: primaryPalette,
};
